import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarbor} from "../../PearlHarbor";
import {IFinalWave} from "../../server/PearlHarborData";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";

export class BombAttackWinPresentation extends PIXI.Container implements StageLayer {
    private _container:PIXI.Sprite;

    constructor() {
        super();
        this.name = "BombAttackWinPresentation";
        this.init();
    }

    public onResize():void {
        if(!this.visible) {
            return;
        }
    }

    public show(row:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        let wins:number = -1;
        (<IFinalWave>PearlHarbor.model.dogfight).filledRows.forEach((hasHit:boolean) => {
            wins += (hasHit ? 1 : 0);
        });
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset("bombAttack" + wins.toString()));
        spine.position.set(0, 0);
        spine.name = "bombAttack" + wins.toString();
        this.onResize();

        const hit:boolean = (<IFinalWave>PearlHarbor.model.dogfight).bombHit[row],
            value:number = PearlHarbor.cocpitBoard.rowSums[row];
        tl.add(() => {
            this._container.rotation = Math.random() * 6 * (Math.PI / 9);
            this.visible = true;
        });
        tl.add(PearlHarbor.cocpitBoard.addRowWinInMiddle(row));
        tl.add([
            () => {
                PearlHarborSoundManager.onFsBomAttackAnimationStart();
                PearlHarborSoundManager.onFsBomAttackShow();
                this._container.addChild(spine);
            },
            PearlHarbor.hitChanceBoard.displayHitChance(row, true),
            new SpineTween(spine, 0, hit ? "hit" : "miss")
        ]);
        tl.add(() => {
            PearlHarborSoundManager.onFsBomAttackHitOrMiss(hit);
            PearlHarbor.hitChanceBoard.displayHitResult(row, true);
        }, hit ? `-=2.1` : `-=0.5`);
        tl.add([
            () => {PearlHarborSoundManager.onFsBombAttackEnd();},
            this.hide()
        ]);
        if(hit) {
            tl.add(PearlHarbor.cocpitBoard.updateMultiplier(value, 0.1));
        } else {
            tl.add(() => {PearlHarbor.cocpitBoard.playMissMul();}, `+=0.4`);
        }
        tl.add(PearlHarbor.cocpitBoard.afterRowWin(row));
        return tl;
    }

    public hide():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this.visible = false;
            this._container.removeChildren();
        });
        return tl;
    }

    public onAbort(level:number):void {}


    private init():void {
        this._container = new PIXI.Sprite();
        this.addChild(this._container);
        this._container.anchor.set(0.5);
        this._container.position.set(360, 360);
        this.visible = false;
    }
}